// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__E0sy7","choiceBoxes":"toolbarselects_choiceBoxes__1yXbX","simpleField":"toolbarselects_simpleField__3DoyU"};